// This file is auto-generated by scripts/generate-icon-illustration-registry.mjs
// Do not edit manually!

export const ICON = {
  AIFilled: () => import('assets/figmaexport/icons/AI_Filled.svg?react'),
  AILine: () => import('assets/figmaexport/icons/AI_Line.svg?react'),
  API: () => import('assets/figmaexport/icons/API.svg?react'),
  AccessoriesBaby: () => import('assets/figmaexport/icons/Accessories_Baby.svg?react'),
  Add: () => import('assets/figmaexport/icons/Add.svg?react'),
  Analytics: () => import('assets/figmaexport/icons/Analytics.svg?react'),
  AnkleBoots: () => import('assets/figmaexport/icons/Ankle_Boots.svg?react'),
  Archive: () => import('assets/figmaexport/icons/Archive.svg?react'),
  ArrowDown: () => import('assets/figmaexport/icons/Arrow_Down.svg?react'),
  ArrowLeft: () => import('assets/figmaexport/icons/Arrow_Left.svg?react'),
  ArrowRight: () => import('assets/figmaexport/icons/Arrow_Right.svg?react'),
  ArrowUp: () => import('assets/figmaexport/icons/Arrow_Up.svg?react'),
  ArticleVisibilityFilled: () => import('assets/figmaexport/icons/Article_Visibility_Filled.svg?react'),
  Automotive: () => import('assets/figmaexport/icons/Automotive.svg?react'),
  Avatar: () => import('assets/figmaexport/icons/Avatar.svg?react'),
  AvatarDouble: () => import('assets/figmaexport/icons/Avatar_Double.svg?react'),
  AvatarExtend: () => import('assets/figmaexport/icons/Avatar_Extend.svg?react'),
  Backpack: () => import('assets/figmaexport/icons/Backpack.svg?react'),
  Bag: () => import('assets/figmaexport/icons/Bag.svg?react'),
  Ballerinas: () => import('assets/figmaexport/icons/Ballerinas.svg?react'),
  Bathrobe: () => import('assets/figmaexport/icons/Bathrobe.svg?react'),
  Bathroom: () => import('assets/figmaexport/icons/Bathroom.svg?react'),
  BeachAccessoires: () => import('assets/figmaexport/icons/Beach_Accessoires.svg?react'),
  BeachShirt: () => import('assets/figmaexport/icons/Beach_Shirt.svg?react'),
  BeachShoes: () => import('assets/figmaexport/icons/Beach_Shoes.svg?react'),
  Beauty: () => import('assets/figmaexport/icons/Beauty.svg?react'),
  BeautySet: () => import('assets/figmaexport/icons/Beauty_Set.svg?react'),
  Belt: () => import('assets/figmaexport/icons/Belt.svg?react'),
  Benchmarking: () => import('assets/figmaexport/icons/Benchmarking.svg?react'),
  Blouse: () => import('assets/figmaexport/icons/Blouse.svg?react'),
  Bodycare: () => import('assets/figmaexport/icons/Bodycare.svg?react'),
  Boots: () => import('assets/figmaexport/icons/Boots.svg?react'),
  Box: () => import('assets/figmaexport/icons/Box.svg?react'),
  Bra: () => import('assets/figmaexport/icons/Bra.svg?react'),
  Bracelet: () => import('assets/figmaexport/icons/Bracelet.svg?react'),
  BridalShoes: () => import('assets/figmaexport/icons/Bridal_Shoes.svg?react'),
  Briefcase: () => import('assets/figmaexport/icons/Briefcase.svg?react'),
  BusinessDress: () => import('assets/figmaexport/icons/Business_Dress.svg?react'),
  Calendar: () => import('assets/figmaexport/icons/Calendar.svg?react'),
  CalendarDays: () => import('assets/figmaexport/icons/Calendar_Days.svg?react'),
  CardiganMen: () => import('assets/figmaexport/icons/Cardigan_Men.svg?react'),
  CardiganWomen: () => import('assets/figmaexport/icons/Cardigan_Women.svg?react'),
  Chat: () => import('assets/figmaexport/icons/Chat.svg?react'),
  Checkmark: () => import('assets/figmaexport/icons/Checkmark.svg?react'),
  ChevronDown: () => import('assets/figmaexport/icons/Chevron_Down.svg?react'),
  ChevronLeft: () => import('assets/figmaexport/icons/Chevron_Left.svg?react'),
  ChevronRight: () => import('assets/figmaexport/icons/Chevron_Right.svg?react'),
  ChevronUp: () => import('assets/figmaexport/icons/Chevron_Up.svg?react'),
  Circle: () => import('assets/figmaexport/icons/Circle.svg?react'),
  ClockFilled: () => import('assets/figmaexport/icons/Clock_Filled.svg?react'),
  ClockOutlined: () => import('assets/figmaexport/icons/Clock_Outlined.svg?react'),
  Clothing: () => import('assets/figmaexport/icons/Clothing.svg?react'),
  Coat: () => import('assets/figmaexport/icons/Coat.svg?react'),
  Code: () => import('assets/figmaexport/icons/Code.svg?react'),
  Collapse: () => import('assets/figmaexport/icons/Collapse.svg?react'),
  ColumnCollapse: () => import('assets/figmaexport/icons/Column_Collapse.svg?react'),
  ColumnExpand: () => import('assets/figmaexport/icons/Column_Expand.svg?react'),
  CombinationClothing: () => import('assets/figmaexport/icons/Combination_Clothing.svg?react'),
  Copy: () => import('assets/figmaexport/icons/Copy.svg?react'),
  Cross: () => import('assets/figmaexport/icons/Cross.svg?react'),
  CrossOctagonFilled: () => import('assets/figmaexport/icons/Cross_Octagon_Filled.svg?react'),
  CrossOctagonOutlined: () => import('assets/figmaexport/icons/Cross_Octagon_Outlined.svg?react'),
  Dashboard: () => import('assets/figmaexport/icons/Dashboard.svg?react'),
  Decoration: () => import('assets/figmaexport/icons/Decoration.svg?react'),
  DentalCare: () => import('assets/figmaexport/icons/Dental_Care.svg?react'),
  Desktop: () => import('assets/figmaexport/icons/Desktop.svg?react'),
  Diamond: () => import('assets/figmaexport/icons/Diamond.svg?react'),
  DoubleChevronLeft: () => import('assets/figmaexport/icons/Double_Chevron_Left.svg?react'),
  DoubleChevronRight: () => import('assets/figmaexport/icons/Double_Chevron_Right.svg?react'),
  Download: () => import('assets/figmaexport/icons/Download.svg?react'),
  Dress: () => import('assets/figmaexport/icons/Dress.svg?react'),
  Earring: () => import('assets/figmaexport/icons/Earring.svg?react'),
  Email: () => import('assets/figmaexport/icons/Email.svg?react'),
  Equalizer: () => import('assets/figmaexport/icons/Equalizer.svg?react'),
  Expand: () => import('assets/figmaexport/icons/Expand.svg?react'),
  EyeClose: () => import('assets/figmaexport/icons/Eye_Close.svg?react'),
  EyeOpen: () => import('assets/figmaexport/icons/Eye_Open.svg?react'),
  File: () => import('assets/figmaexport/icons/File.svg?react'),
  FileStack: () => import('assets/figmaexport/icons/File_Stack.svg?react'),
  FlagFilled: () => import('assets/figmaexport/icons/Flag_Filled.svg?react'),
  FlagOutlined: () => import('assets/figmaexport/icons/Flag_Outlined.svg?react'),
  Floppydisk: () => import('assets/figmaexport/icons/Floppydisk.svg?react'),
  Fragrance: () => import('assets/figmaexport/icons/Fragrance.svg?react'),
  FunnelFilled: () => import('assets/figmaexport/icons/Funnel_Filled.svg?react'),
  FunnelOutlined: () => import('assets/figmaexport/icons/Funnel_Outlined.svg?react'),
  Furniture: () => import('assets/figmaexport/icons/Furniture.svg?react'),
  Gift: () => import('assets/figmaexport/icons/Gift.svg?react'),
  Globe: () => import('assets/figmaexport/icons/Globe.svg?react'),
  Glove: () => import('assets/figmaexport/icons/Glove.svg?react'),
  GraphCompare: () => import('assets/figmaexport/icons/Graph_Compare.svg?react'),
  HairCare: () => import('assets/figmaexport/icons/Hair_Care.svg?react'),
  HandShake: () => import('assets/figmaexport/icons/Hand_Shake.svg?react'),
  Handler: () => import('assets/figmaexport/icons/Handler.svg?react'),
  Hanger: () => import('assets/figmaexport/icons/Hanger.svg?react'),
  Hat: () => import('assets/figmaexport/icons/Hat.svg?react'),
  Headset: () => import('assets/figmaexport/icons/Headset.svg?react'),
  HeartFilled: () => import('assets/figmaexport/icons/Heart_Filled.svg?react'),
  HeartOutlined: () => import('assets/figmaexport/icons/Heart_Outlined.svg?react'),
  Help: () => import('assets/figmaexport/icons/Help.svg?react'),
  HelpFilled: () => import('assets/figmaexport/icons/Help_Filled.svg?react'),
  Home: () => import('assets/figmaexport/icons/Home.svg?react'),
  HomeAndLiving: () => import('assets/figmaexport/icons/Home_And_Living.svg?react'),
  HouseShoes: () => import('assets/figmaexport/icons/House_Shoes.svg?react'),
  InformationFilled: () => import('assets/figmaexport/icons/Information_Filled.svg?react'),
  InformationOutlined: () => import('assets/figmaexport/icons/Information_Outlined.svg?react'),
  InsightsFeed: () => import('assets/figmaexport/icons/Insights_Feed.svg?react'),
  InsightsProFilled: () => import('assets/figmaexport/icons/Insights_Pro_Filled.svg?react'),
  Investigate: () => import('assets/figmaexport/icons/Investigate.svg?react'),
  Jacket: () => import('assets/figmaexport/icons/Jacket.svg?react'),
  Jeans: () => import('assets/figmaexport/icons/Jeans.svg?react'),
  JewelrySet: () => import('assets/figmaexport/icons/Jewelry_Set.svg?react'),
  Jumpsuit: () => import('assets/figmaexport/icons/Jumpsuit.svg?react'),
  Kitchen: () => import('assets/figmaexport/icons/Kitchen.svg?react'),
  Knitwear: () => import('assets/figmaexport/icons/Knitwear.svg?react'),
  LaceUpShoes: () => import('assets/figmaexport/icons/Lace_Up_Shoes.svg?react'),
  Lamp: () => import('assets/figmaexport/icons/Lamp.svg?react'),
  LanguageOutlined: () => import('assets/figmaexport/icons/Language_Outlined.svg?react'),
  Laptop: () => import('assets/figmaexport/icons/Laptop.svg?react'),
  LightBulb: () => import('assets/figmaexport/icons/Light_Bulb.svg?react'),
  LineGraph: () => import('assets/figmaexport/icons/Line_Graph.svg?react'),
  List: () => import('assets/figmaexport/icons/List.svg?react'),
  Loafers: () => import('assets/figmaexport/icons/Loafers.svg?react'),
  LockClosed: () => import('assets/figmaexport/icons/Lock_Closed.svg?react'),
  LockOpen: () => import('assets/figmaexport/icons/Lock_Open.svg?react'),
  LogOut: () => import('assets/figmaexport/icons/Log_Out.svg?react'),
  Loungewear: () => import('assets/figmaexport/icons/Loungewear.svg?react'),
  MagnifyingGlass: () => import('assets/figmaexport/icons/Magnifying_Glass.svg?react'),
  MakeUp: () => import('assets/figmaexport/icons/Make_Up.svg?react'),
  MatchingSets: () => import('assets/figmaexport/icons/Matching_Sets.svg?react'),
  MenuCollapse: () => import('assets/figmaexport/icons/Menu_Collapse.svg?react'),
  MenuExpand: () => import('assets/figmaexport/icons/Menu_Expand.svg?react'),
  MenuPlaceholder: () => import('assets/figmaexport/icons/Menu_Placeholder.svg?react'),
  More: () => import('assets/figmaexport/icons/More.svg?react'),
  Move: () => import('assets/figmaexport/icons/Move.svg?react'),
  Mules: () => import('assets/figmaexport/icons/Mules.svg?react'),
  Nails: () => import('assets/figmaexport/icons/Nails.svg?react'),
  NecklaceMen: () => import('assets/figmaexport/icons/Necklace_Men.svg?react'),
  NecklaceWomen: () => import('assets/figmaexport/icons/Necklace_Women.svg?react'),
  Nightwear: () => import('assets/figmaexport/icons/Nightwear.svg?react'),
  NightwearKids: () => import('assets/figmaexport/icons/Nightwear_Kids.svg?react'),
  NotificationFilled: () => import('assets/figmaexport/icons/Notification_Filled.svg?react'),
  OpenExternal: () => import('assets/figmaexport/icons/Open_External.svg?react'),
  OpenShoes: () => import('assets/figmaexport/icons/Open_Shoes.svg?react'),
  OutdoorShoes: () => import('assets/figmaexport/icons/Outdoor_Shoes.svg?react'),
  PanZoom: () => import('assets/figmaexport/icons/Pan_Zoom.svg?react'),
  Paperclip: () => import('assets/figmaexport/icons/Paperclip.svg?react'),
  PauseFilled: () => import('assets/figmaexport/icons/Pause_Filled.svg?react'),
  PauseOutlined: () => import('assets/figmaexport/icons/Pause_Outlined.svg?react'),
  Pencil: () => import('assets/figmaexport/icons/Pencil.svg?react'),
  PieChart: () => import('assets/figmaexport/icons/Pie_Chart.svg?react'),
  Placeholder: () => import('assets/figmaexport/icons/Placeholder.svg?react'),
  PlayFilled: () => import('assets/figmaexport/icons/Play_Filled.svg?react'),
  PlayOutlined: () => import('assets/figmaexport/icons/Play_Outlined.svg?react'),
  Plug: () => import('assets/figmaexport/icons/Plug.svg?react'),
  Price: () => import('assets/figmaexport/icons/Price.svg?react'),
  Printer: () => import('assets/figmaexport/icons/Printer.svg?react'),
  ProfileFilled: () => import('assets/figmaexport/icons/Profile_Filled.svg?react'),
  ProfileLine: () => import('assets/figmaexport/icons/Profile_Line.svg?react'),
  Profitability: () => import('assets/figmaexport/icons/Profitability.svg?react'),
  Pumps: () => import('assets/figmaexport/icons/Pumps.svg?react'),
  Refresh: () => import('assets/figmaexport/icons/Refresh.svg?react'),
  Remove: () => import('assets/figmaexport/icons/Remove.svg?react'),
  Return: () => import('assets/figmaexport/icons/Return.svg?react'),
  Ring: () => import('assets/figmaexport/icons/Ring.svg?react'),
  Rotate: () => import('assets/figmaexport/icons/Rotate.svg?react'),
  RowCollapse: () => import('assets/figmaexport/icons/Row_Collapse.svg?react'),
  RowExpand: () => import('assets/figmaexport/icons/Row_Expand.svg?react'),
  Sale: () => import('assets/figmaexport/icons/Sale.svg?react'),
  Sandals: () => import('assets/figmaexport/icons/Sandals.svg?react'),
  Scarf: () => import('assets/figmaexport/icons/Scarf.svg?react'),
  Settings: () => import('assets/figmaexport/icons/Settings.svg?react'),
  SettingsNavigation: () => import('assets/figmaexport/icons/Settings_Navigation.svg?react'),
  Shapes: () => import('assets/figmaexport/icons/Shapes.svg?react'),
  Share: () => import('assets/figmaexport/icons/Share.svg?react'),
  ShavingMen: () => import('assets/figmaexport/icons/Shaving_Men.svg?react'),
  Shipping: () => import('assets/figmaexport/icons/Shipping.svg?react'),
  Shirt: () => import('assets/figmaexport/icons/Shirt.svg?react'),
  ShirtBlouse: () => import('assets/figmaexport/icons/Shirt_Blouse.svg?react'),
  ShoeAccessories: () => import('assets/figmaexport/icons/Shoe_Accessories.svg?react'),
  ShoesBusinessMen: () => import('assets/figmaexport/icons/Shoes_Business_Men.svg?react'),
  ShoesHighHeels: () => import('assets/figmaexport/icons/Shoes_High_Heels.svg?react'),
  ShoppingCart: () => import('assets/figmaexport/icons/Shopping_Cart.svg?react'),
  ShortsMen: () => import('assets/figmaexport/icons/Shorts_Men.svg?react'),
  ShortsWomen: () => import('assets/figmaexport/icons/Shorts_Women.svg?react'),
  ShoulderBag: () => import('assets/figmaexport/icons/Shoulder_Bag.svg?react'),
  Skincare: () => import('assets/figmaexport/icons/Skincare.svg?react'),
  Skirt: () => import('assets/figmaexport/icons/Skirt.svg?react'),
  Smartwatch: () => import('assets/figmaexport/icons/Smartwatch.svg?react'),
  Sneakers: () => import('assets/figmaexport/icons/Sneakers.svg?react'),
  Socks: () => import('assets/figmaexport/icons/Socks.svg?react'),
  SortingAscending: () => import('assets/figmaexport/icons/Sorting_Ascending.svg?react'),
  SortingDescending: () => import('assets/figmaexport/icons/Sorting_Descending.svg?react'),
  Spark: () => import('assets/figmaexport/icons/Spark.svg?react'),
  SpecialItem: () => import('assets/figmaexport/icons/Special_Item.svg?react'),
  Spinner: () => import('assets/figmaexport/icons/Spinner.svg?react'),
  SportShoes: () => import('assets/figmaexport/icons/Sport_Shoes.svg?react'),
  SportsEquipment: () => import('assets/figmaexport/icons/Sports_Equipment.svg?react'),
  Sportsbag: () => import('assets/figmaexport/icons/Sportsbag.svg?react'),
  Sportswear: () => import('assets/figmaexport/icons/Sportswear.svg?react'),
  StopFilled: () => import('assets/figmaexport/icons/Stop_Filled.svg?react'),
  StopOutlined: () => import('assets/figmaexport/icons/Stop_Outlined.svg?react'),
  Store: () => import('assets/figmaexport/icons/Store.svg?react'),
  SubArrowRight: () => import('assets/figmaexport/icons/Sub_Arrow_Right.svg?react'),
  SuccessFilled: () => import('assets/figmaexport/icons/Success_Filled.svg?react'),
  SuccessOutlined: () => import('assets/figmaexport/icons/Success_Outlined.svg?react'),
  Suit: () => import('assets/figmaexport/icons/Suit.svg?react'),
  Suncare: () => import('assets/figmaexport/icons/Suncare.svg?react'),
  Sunglasses: () => import('assets/figmaexport/icons/Sunglasses.svg?react'),
  Support: () => import('assets/figmaexport/icons/Support.svg?react'),
  Sweatshirt: () => import('assets/figmaexport/icons/Sweatshirt.svg?react'),
  SwimwearMen: () => import('assets/figmaexport/icons/Swimwear_Men.svg?react'),
  SwimwearWomen: () => import('assets/figmaexport/icons/Swimwear_Women.svg?react'),
  SwinsuitWomen: () => import('assets/figmaexport/icons/Swinsuit_Women.svg?react'),
  TShirt: () => import('assets/figmaexport/icons/T_Shirt.svg?react'),
  Table: () => import('assets/figmaexport/icons/Table.svg?react'),
  Tag: () => import('assets/figmaexport/icons/Tag.svg?react'),
  Tall: () => import('assets/figmaexport/icons/Tall.svg?react'),
  Textiles: () => import('assets/figmaexport/icons/Textiles.svg?react'),
  ThreeLayers: () => import('assets/figmaexport/icons/Three_Layers.svg?react'),
  ThumbsDownFilled: () => import('assets/figmaexport/icons/Thumbs_Down_Filled.svg?react'),
  ThumbsDownOutlined: () => import('assets/figmaexport/icons/Thumbs_Down_Outlined.svg?react'),
  ThumbsUpFilled: () => import('assets/figmaexport/icons/Thumbs_Up_Filled.svg?react'),
  ThumbsUpOutlined: () => import('assets/figmaexport/icons/Thumbs_Up_Outlined.svg?react'),
  Tie: () => import('assets/figmaexport/icons/Tie.svg?react'),
  Trading: () => import('assets/figmaexport/icons/Trading.svg?react'),
  Trash: () => import('assets/figmaexport/icons/Trash.svg?react'),
  TrendDown: () => import('assets/figmaexport/icons/Trend_Down.svg?react'),
  TrendFlat: () => import('assets/figmaexport/icons/Trend_Flat.svg?react'),
  TrendUp: () => import('assets/figmaexport/icons/Trend_Up.svg?react'),
  TriangleDown: () => import('assets/figmaexport/icons/Triangle_Down.svg?react'),
  TriangleDownDescending: () => import('assets/figmaexport/icons/Triangle_Down_Descending.svg?react'),
  TriangleUp: () => import('assets/figmaexport/icons/Triangle_Up.svg?react'),
  TriangleUpAscending: () => import('assets/figmaexport/icons/Triangle_Up_Ascending.svg?react'),
  TriangleUpDown: () => import('assets/figmaexport/icons/Triangle_Up_Down.svg?react'),
  Trousers: () => import('assets/figmaexport/icons/Trousers.svg?react'),
  Truck: () => import('assets/figmaexport/icons/Truck.svg?react'),
  TruckFast: () => import('assets/figmaexport/icons/Truck_Fast.svg?react'),
  TruckPremium: () => import('assets/figmaexport/icons/Truck_Premium.svg?react'),
  TruckSustainable: () => import('assets/figmaexport/icons/Truck_Sustainable.svg?react'),
  TwoLayers: () => import('assets/figmaexport/icons/Two_Layers.svg?react'),
  Underpants: () => import('assets/figmaexport/icons/Underpants.svg?react'),
  Undershirt: () => import('assets/figmaexport/icons/Undershirt.svg?react'),
  Underwear: () => import('assets/figmaexport/icons/Underwear.svg?react'),
  UnderwearMen: () => import('assets/figmaexport/icons/Underwear_Men.svg?react'),
  UnderwearMultipackWomen: () => import('assets/figmaexport/icons/Underwear_Multipack_Women.svg?react'),
  UnderwearWomen: () => import('assets/figmaexport/icons/Underwear_Women.svg?react'),
  UploadCloud: () => import('assets/figmaexport/icons/Upload_Cloud.svg?react'),
  Vest: () => import('assets/figmaexport/icons/Vest.svg?react'),
  Warehouse: () => import('assets/figmaexport/icons/Warehouse.svg?react'),
  WarningFilledTriangle: () => import('assets/figmaexport/icons/Warning_Filled_Triangle.svg?react'),
  WarningOutlinedTriangle: () => import('assets/figmaexport/icons/Warning_Outlined_Triangle.svg?react'),
  Watch: () => import('assets/figmaexport/icons/Watch.svg?react'),
  Waves: () => import('assets/figmaexport/icons/Waves.svg?react'),
  Weight: () => import('assets/figmaexport/icons/Weight.svg?react'),
} as const;

export type IconName = keyof typeof ICON;
